var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButtonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": ".pressed-image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.5,
    height: 87.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "deleteButtonActive_svg__a",
    x: 0,
    y: 0,
    width: 87.5,
    height: 87.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b7b7b7",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deleteButtonActive_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\u9577\\u65B9\\u5F62 265",
    width: 84,
    height: 84,
    rx: 16,
    fill: "#828282"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 13",
    d: "M38.702 76.548a12.07 12.07 0 01-2.2-.2 11.722 11.722 0 01-9.633-3.871l-19.7-21.44a12 12 0 010-16.24l19.7-21.44a11.732 11.732 0 0110.47-3.78 12.123 12.123 0 011.363-.077h28.893a12 12 0 0112 12v43.049a12 12 0 01-12 12z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 122",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 6,
    d: "M33 25l36 36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 123",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 6,
    d: "M69 25L33 61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButtonActive);
export default __webpack_public_path__ + "static/media/deleteButtonActive.20d113aa0f15119d.svg";
export { ForwardRef as ReactComponent };